export const COUNTRIES_REQUEST = 'COUNTRIES_REQUEST'
export const COUNTRIES_SUCCESS = 'COUNTRIES_SUCCESS'
export const COUNTRIES_FALIURE = 'COUNTRIES_FALIURE'
export const STATES_REQUEST = 'STATES_REQUEST'
export const STATES_SUCCESS = 'STATES_SUCCESS'
export const STATES_FALIURE = 'STATES_FALIURE'
